module.exports = __webpack_public_path__ + "static/media/export.3bc4a346.svg";